import { createContext } from 'react';
import { PAGER_DEFAULT_ELEM } from './types.js';

var PagerContext = /*#__PURE__*/createContext({
  PagerElem: PAGER_DEFAULT_ELEM
});

export { PagerContext };
